import { Card, DateInput, Select, Textarea } from "components";
import { Controller, useFormContext } from "react-hook-form";
import { AdjustmentInventoryType } from "../utils";
import { useEmployee } from "utils";
import moment from "moment";
import { useContext } from "react";
import { LocationContext } from "contexts";
import { useAdjustmentStore } from "../store/adjusmentInventoryStore"

export function HeaderSection(props: {
    isEdit?: boolean
}): JSX.Element {

    const { control } = useFormContext<AdjustmentInventoryType>()
    const { data, isLoading } = useContext(LocationContext)
    const { dataEmployee, isLoadingEmployee } = useEmployee()
    const { isListAvailable } = useAdjustmentStore()

    return (
        <Card>
            <Card.Body>
                <section className="grid lg:grid-cols-2 gap-x-6 gap-y-3">
                    <section className="flex flex-col gap-3">
                        <Controller
                            name="location_id"
                            control={control}
                            render={({ field, fieldState }) => (
                                <Select
                                    label="LOCATION"
                                    placeholder="Select Location"
                                    error={fieldState.error?.message}
                                    isLoading={isLoading}
                                    value={data.find((item) => item.value === field.value) ?? null}
                                    options={data}
                                    onChange={(res) => {
                                        if (res) {
                                            field.onChange(res.value)
                                        }
                                    }}
                                    isDisabled={isListAvailable || props.isEdit}
                                />
                            )}
                        />

                        <Controller
                            name="employee_id"
                            control={control}
                            render={({ field, fieldState }) => (
                                <Select
                                    label="EMPLOYEE"
                                    placeholder="Select Employee"
                                    error={fieldState.error?.message}
                                    isLoading={isLoadingEmployee}
                                    value={
                                        dataEmployee.find((item) => item.value.toString() === field.value) ?? null
                                    }
                                    options={dataEmployee}
                                    onChange={(res) => field.onChange(res?.value)}
                                    isDisabled={props.isEdit}
                                />
                            )}
                        />
                    </section>

                    <section className="flex flex-col gap-3">

                        <Controller
                            name="transaction_date"
                            control={control}
                            render={({ field }) => (
                                <DateInput
                                    label="DATE"
                                    selected={moment(field.value).toDate()}
                                    onChange={(date) => {
                                        // Vars
                                        const selectedDate: string =
                                            moment(date).format("YYYY-MM-DD")

                                        field.onChange(selectedDate)
                                    }}
                                    disabled={props.isEdit}
                                />
                            )}
                        />

                        <Controller
                            name="memo"
                            control={control}
                            render={({ field, fieldState }) => (
                                <Textarea
                                    {...field}
                                    label="MEMO"
                                    error={fieldState.error?.message}
                                    disabled={props.isEdit}
                                />
                            )}
                        />
                    </section>
                </section>
            </Card.Body>
        </Card>
    )
}